import React from "react";
import styles from "./ClientDocuments.module.css";
import { Modal, Row, Button, Col, OverlayTrigger, Tooltip, Dropdown } from "react-bootstrap";
import { useMemo, useState, useRef, useEffect } from "react";
import type { IRowNode } from 'ag-grid-community';


import * as Icon from "react-bootstrap-icons";
import UploadDocuments from "../components/UploadDocumentsModal/UploadDocuments";
import { ComparisonModal } from "../components/ComparisonModal/ComparisonModal";
import DocumentPreviewModal from "../components/DocumentPreviewModal/DocumentPreviewModal";
import { CreatedDateRenderer } from "pages/K1/K1LandingPage/K1HelperFunctions";
import RefreshButton from "reusable-components/CustomButtonComponent/RefreshButton";
import { CustomButton } from "reusable-components/CustomButtonComponent/button";
import { downloadDocument, getPBCDocumentsById, getReturnIds } from "./ClientDocuments.service";
import Select, { type StylesConfig, type GroupBase } from "react-select";
import { ComparisonFullWindowModal } from "pages/K1/CompareK1Page/ComparisonFullWindowModal";
import InternalK1Hierarchy from "../components/InternalK1Hierarchy/InternalK1Hierarchy";
import InternalK1PullDataModal from "../components/InternalK1PullDataModal/InternalK1PullDataModal";
import { InternalK1ParentData } from "../components/InternalK1PullDataModal/InternalK1PullDataModal";
import ConfirmImportToTaxModal from "../components/ConfirmImportToTaxModal/ConfirmImportToTaxModal";
import ConfirmExportToExcelModal from "../components/ConfirmExportToExcelModal/ConfirmExportToExcelModal";
import { StatusCellRenderer } from "./GridStatuses";
import CygnusGrid from "pages/CygnusGrid/CygnusGrid";
import ActivityMapping from "../components/ActivityMapping/ActivityMapping";

/**
 * ClientDocuments Component
 */


const ClientDocuments: React.FC<any> = ({
  show,
  onHide,
  clientmasterid,
  clientid,
  clientname,
  transporter
}) => {
  const [refreshGrid, setRefreshGrid] = useState(false);
  const [documentsData, setDocumentsData] = useState<any[]>([]);
  const [activeDocumentIndex, setActiveDocumentIndex] = useState<number | null>(null);
  const [uploadDocumentsModal, setUploadDocumentsModal] = useState(false)
  const [pdfFileUrl, setPdfFileUrl] = useState<string | null>();
  const [documentPreviewModal, setDocumentPreviewModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [comparisonModalShow, setComparisonModalShow] = useState(false);
  const [comparisonData, setComparisonData] = useState({});
  const [fileUploadingFlag, setFileUploadingFlag] = useState(false);
  const [showExcelExportModal, setShowExcelExportModal] = useState(false);
  const [key, setKey] = useState<number | undefined>(undefined);
  const [flowOrchestratorId, setFlowOrchestratorId] = useState<number | null>(null);
  const [returnIdOptions, setReturnIdOptions] = useState<any[]>([]);
  // typed styles config (single-select -> second generic = false)
  type ReturnIdOption = { label: string; value: string };
    const selectStyles: StylesConfig<ReturnIdOption, false, GroupBase<ReturnIdOption>> = {
      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      menu: (base) => ({ ...base, zIndex: 9999 }),
    };
  const [selectedReturnId, setSelectedReturnId] = useState<any>(null);

  // New: indicates whether return id api call has been made
  // as grid is not based on return id. We need to populate it after return is fetched
  const [effectiveReturnId, setEffectiveReturnId] = useState<string | null>(null);


  const [comparisonWindowModalState, setComparisonWindowModalState] = useState(false);
  const [totalPagesOfSelectedFile, setTotalPages] = useState(0);

  const [showInternalK1HierarchyModal, setShowInternalK1HierarchyModal] = useState(false);
  const [showInternalK1PullModal, setShowInternalK1PullModal] = useState(false);

  type DocParentMap = Record<number, string>;
  const [documentInternalK1SelectedParentId, setDocumentInternalK1SelectedParentId] = useState<DocParentMap>({});

  const [selectedParent, setSelectedParent] = useState<InternalK1ParentData | null>(null);
  const [pendingDocId, setPendingDocId] = useState<string | null>(null);
  const clickedRowNodeRef = useRef<IRowNode<any> | null>(null);

  const selectableStatuses = ['Completed', 'Complete', "Approved", "Return Selected", "Verified"]; 

  const gridStyle = useMemo(() => ({ height: "73vh", width: "100%" }), []);
  const gridRef = useRef(null);

  const [importToTaxFlag, setImportToTaxFlag] = useState(false);
  const [importToTaxConfirmModal, setImportToTaxConfirmModal] = useState(false);
  const [isOptionValid, setIsOptionValid] = useState(false);
  const [showActivityMappingmodal, setShowActivityMappingmodal] = useState(false);
  const [parentReturnId, setParentReturnId] = useState<any>(null);
  const [parentName, setParentName] = useState<any>(null);
  const [sourceIdentifier, setSourceIdentifier] = useState<any>(null);
  const [documentId, setDocumentId] = useState<any>(null);
  const [internalK1Activities, setInternalK1Activities] = useState<any[]>([]);
  const [fileType, setFileType] = useState<string>("");
  const [flowOrchestratorIdExcelImport, setFlowOrchestratorIdExcelImport] = useState<number | null>(null);

  const getDocumentsByClientId = async () => {
    setRefreshGrid(true)
    // const clientDocuments: ClientDocumentItem[] = await getDocumentsById(clientmasterid);
    const pbcDocuments: any = await getPBCDocumentsById(clientmasterid, selectedReturnId?.value);

    if (pbcDocuments !== undefined) {
      // add InternalK1SelectedReturnId to each document
      pbcDocuments.data.forEach((doc: any) => {
        // if there is already a cash for this document, (documentInternalK1SelectedParentId)
        const saved = documentInternalK1SelectedParentId[doc.DocumentId];
        if (saved !== undefined) {
            doc.InternalK1SelectedReturnId = saved;
            doc.Status = 'Return Selected';

            doc.FileName = { type: 'button', placeholder: saved, url: '' };
          } else {
            doc.InternalK1SelectedReturnId = selectedReturnId?.value ?? '';
          }
        
      });
      setDocumentsData(pbcDocuments.data)
      setKey(pbcDocuments.data.length)
      setFlowOrchestratorId(pbcDocuments.flowOrchestratorId)
      setFlowOrchestratorIdExcelImport(pbcDocuments.flowOrchestratorIdExcelImport)
    }
    setRefreshGrid(false)
  }

  // Load Return IDs when the client changes
  useEffect(() => {
    void getAllReturnIds(); // sets returnIdOptions + selectedReturnId
  }, [clientmasterid]);

  // After selectedReturnId is set/changes, load documents
  useEffect(() => {    
    if (!isOptionValid) return;
    void getDocumentsByClientId();        // uses selectedReturnId inside
  }, [selectedReturnId, isOptionValid]);

  const downloadDocumentByDocumentId = async (documentId: any, documentType: any) => {
    const document = await downloadDocument(documentId, documentType);
    return document;
  }

  const setPropsForActivityMappingModal = (returnId: any, taxId: any, documentId: any, parentName: any) => {
    setParentReturnId(returnId);
    setSourceIdentifier(taxId);
    setDocumentId(documentId);
    setParentName(parentName);
    // setInternalK1Activities([]);   not setting it to [] because we want to retain previous selections if user opens modal again
    setShowActivityMappingmodal(true);
  }

  const DocumentActionsCellRenderer = (props: any) => {
    const viewDocumentClick = async () => {
      try {
        const blob = await downloadDocumentByDocumentId(props.data.DocumentId, props.data.DocumentType);
        const url = window.URL.createObjectURL(blob);
        setPdfFileUrl(url);
        setDocumentPreviewModal(true);
      } catch (error) {
        console.error('Error viewing document:', error);
      }
    };


    const setupInternalK1ParentReturnIdSelection = () => {

      const parentInfo: InternalK1ParentData = {
        "DocumentId": props.data.DocumentId,
        "SourceName": props.data.SourceName,
        "ClientMasterId": props.data.ClientMasterId,
        "ParentClientMasterId": props.data.ParentClientMasterId
      }
      setSelectedParent(parentInfo);
      setActiveDocumentIndex(props.rowIndex);
      setPendingDocId(props.data.DocumentId);
      setShowInternalK1PullModal(true);
      // console.log("document renderer props", props);
    }

    const downloadDocuments = async () => {
      const blob = await downloadDocumentByDocumentId(props.data.DocumentId, props.data.DocumentType);
      const href = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', `${props.data.FileName?.placeholder}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    // console.log(props)
    const valid_statuses = ["complete", "draft", "verified", "ready for review", "pending", "approved", "unverified", "completed"];    

    return (
      <div>
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 0, hide: 100 }}
          overlay={
            props.data.DocumentType !== "Internal Schedule K-1"
              ? <Tooltip id="button-tooltip">{props.data.DocumentType === "Schedule K-1" ? "Click to compare" : "Click to compare"}</Tooltip>
              : <></>
          }
        >
          <span className={styles.tooltipWrapper}>
            <Button onClick={() => {
              setComparisonData({
                "file": props.data.FileName.url,
                "activekone": props.data,
                "apidata": documentsData
              });
              { props.data.DocumentType === "Schedule K-1" ? setComparisonWindowModalState(true) : setComparisonModalShow(true) }
            }}
              style={{
                cursor: "pointer",
                backgroundColor: "transparent",
                color: valid_statuses.includes(props.data.Status?.toLowerCase())
                  && props.data.DocumentType !== "Internal Schedule K-1"                  
                  ? "var(--theme1_primary)"
                  : "lightgrey",
                border: "0px solid white",
                pointerEvents: valid_statuses.includes(props.data.Status?.toLowerCase())
                  && props.data.DocumentType !== "Internal Schedule K-1"                  
                  ? "all"
                  : "none"
              }}
              className={styles.actionButton}
            >
              <Icon.BookHalf
                style={{
                  fontSize: 15,
                  color: valid_statuses.includes(props.data.Status?.toLowerCase())
                    && props.data.DocumentType !== "Internal Schedule K-1"                    
                    ? "var(--theme1_primary)"
                    : "lightgrey",
                  opacity: props.data.DocumentType !== "Internal Schedule K-1"
                    ? "1"
                    : "0"
                }}
              />
            </Button>
          </span>
        </OverlayTrigger>
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={
            props.data.DocumentType !== "Internal Schedule K-1"
              ? <Tooltip id="button-tooltip">View Document</Tooltip>
              : <></>
          }
        // error={true}
        >
          <span className={styles.tooltipWrapper}>
            <Button
              style={{
                color: valid_statuses.includes(props.data.Status?.toLowerCase())
                  && props.data.DocumentType !== "Internal Schedule K-1"
                  ? "var(--theme1_primary)"
                  : "lightgrey",
                pointerEvents: valid_statuses.includes(props.data.Status?.toLowerCase())
                  && props.data.DocumentType !== "Internal Schedule K-1"
                  ? "all"
                  : "none"
              }}
              className={styles.actionButton}
              onClick={() => viewDocumentClick()}
            >
              <Icon.Eye className={styles.iconsmall} style={{
                color: valid_statuses.includes(props.data.Status?.toLowerCase())
                  && props.data.DocumentType !== "Internal Schedule K-1"
                  ? "var(--theme1_primary)"
                  : "lightgrey",
                opacity: props.data.DocumentType !== "Internal Schedule K-1"
                  ? "1"
                  : "0"
              }} />
            </Button>
          </span>
        </OverlayTrigger>
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={
            props.data.DocumentType !== "Internal Schedule K-1"
              ? <Tooltip id="button-tooltip">Download Document</Tooltip>
              : <></>
          }
        // error={true}          
        >
          <div className={styles.tooltipWrapper}>
            <Button
              className={styles.actionButton}
              style={{
                color: valid_statuses.includes(props.data.Status?.toLowerCase())
                  && props.data.DocumentType !== "Internal Schedule K-1"
                  ? "var(--theme1_primary)"
                  : "lightgrey",
                pointerEvents: valid_statuses.includes(props.data.Status?.toLowerCase())
                  && props.data.DocumentType !== "Internal Schedule K-1"
                  ? "all"
                  : "none"
              }}
              onClick={() => downloadDocuments()}>
              <Icon.Download className={styles.iconsmall} style={{
                color: valid_statuses.includes(props.data.Status?.toLowerCase())
                  && props.data.DocumentType !== "Internal Schedule K-1"
                  ? "var(--theme1_primary)"
                  : "lightgrey",
                opacity: props.data.DocumentType !== "Internal Schedule K-1"
                  ? "1"
                  : "0"
              }} />
            </Button>
          </div>
        </OverlayTrigger>
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={
            props.data.DocumentType === "Internal Schedule K-1"
              ? <Tooltip id="button-tooltip">View Hierarchy</Tooltip>
              : <></>
          }
        // error={true}
        >
          <span className={styles.tooltipWrapper}>
            <Button
              style={{
                color: props.data.DocumentType === "Internal Schedule K-1"
                  ? "var(--theme1_primary)"
                  : "lightgrey",
                pointerEvents: props.data.DocumentType === "Internal Schedule K-1"
                  ? "all"
                  : "none",
              }}
              className={styles.actionButton}
              onClick={() => setShowInternalK1HierarchyModal(true)}
            >
              <Icon.Diagram3 className={styles.iconsmall} style={{
                color: props.data.DocumentType === "Internal Schedule K-1"
                  ? "var(--theme1_primary)"
                  : "lightgrey",
                opacity: props.data.DocumentType === "Internal Schedule K-1"
                  ? "1"
                  : "0",
                transform: "scaleY(-1)"
              }} />
            </Button>
          </span>
        </OverlayTrigger>
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={
            props.data.DocumentType === "Internal Schedule K-1"
              ? <Tooltip id="button-tooltip">Select Return Id</Tooltip>
              : <></>
          }
        // error={true}
        >
          <span className={styles.tooltipWrapper}>
            <Button
              style={{
                color: props.data.DocumentType === "Internal Schedule K-1"
                  ? "var(--theme1_primary)"
                  : "lightgrey",
                pointerEvents: props.data.DocumentType === "Internal Schedule K-1"
                  ? "all"
                  : "none"
              }}
              className={styles.actionButton}
              onClick={() => setupInternalK1ParentReturnIdSelection()}
            >
              <Icon.BoxArrowDown className={styles.iconsmall} style={{
                color: props.data.DocumentType === "Internal Schedule K-1"
                  ? "var(--theme1_primary)"
                  : "lightgrey",
                opacity: props.data.DocumentType === "Internal Schedule K-1"
                  ? "1"
                  : "0"
              }} />
            </Button>
          </span>
        </OverlayTrigger>
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={
            props.data.FileName.placeholder === "" ? (
              <Tooltip id="tooltip">Please select a Return Id by clicking ⬇️ in actions</Tooltip>
            ) : props.data.DocumentType === "Internal Schedule K-1" ? (
              <Tooltip id="tooltip">Select Activity Mapping</Tooltip>
            ) : (
              <></>
            )
          }
        // error={true}
        >
          <span className={styles.tooltipWrapper}>
            <Button
              style={{
                color: props.data.DocumentType === "Internal Schedule K-1" && props.data.FileName.placeholder !== ""
                  ? "var(--theme1_primary)"
                  : "lightgrey",
                pointerEvents: props.data.DocumentType === "Internal Schedule K-1" && props.data.FileName.placeholder !== ""
                  ? "all"
                  : "none"
              }}
              className={styles.actionButton}
              onClick={() => {
                setPropsForActivityMappingModal(props.data.FileName.placeholder, props.data.SourceTaxId, props.data.DocumentId, props.data.SourceName)
              }}
            >
              <Icon.ArrowLeftRight className={styles.iconsmall} style={{
                color: props.data.DocumentType === "Internal Schedule K-1" && props.data.FileName.placeholder !== ""
                  ? "var(--theme1_primary)"
                  : "lightgrey",
                opacity: props.data.DocumentType === "Internal Schedule K-1"
                  ? "1"
                  : "0"
              }} />
            </Button>
          </span>
        </OverlayTrigger>
      </div>
    )
  }


  const defaultDocumentColumnDefs = [
    {
      colId: "type",
      headerName: "Type",
      valueGetter: (params: any) => params.data.FormType || params.data.DocumentType || '',
      flex: 1,
      maxWidth: 135,
      minWidth: 135,
      sortable: false,
      pinned: "left"
    },
    {
      headerName: "Source",
      field: "SourceName",
      flex: 1,
      sortable: false
    },
    {
      headerName: "Identifier",
      field: "SourceTaxId",
      flex: 1,
    },
    {
      headerName: "Source Data",
      field: "FileName",
      flex: 1.5,
      valueGetter: (params: any) => params.data.FileName?.placeholder ?? ''
    },
    {
      headerName: "Status",
      field: "Status",
      flex: 1,
      sortable: false,
      cellRenderer: StatusCellRenderer,
      cellRendererParams: {
        onPendingUpload: () => setUploadDocumentsModal(true),
      },
      cellStyle: { overflow: 'visible' }, // lets the glow breathe a bit
    },
    {
      headerName: "Uploaded Date",
      field: "UploadedDate",
      flex: 1,
      sortable: false,
      cellRenderer: (params: any) => CreatedDateRenderer(params.data.UploadedDate)
    },
    {
      headerName: "Tax Status",
      field: "TaxStatus",
      flex: 1,
      sortable: false,
      cellRenderer: StatusCellRenderer,
      cellRendererParams: {
        onPendingUpload: () => setUploadDocumentsModal(true),
      },
      cellStyle: { overflow: 'visible' }, // lets the glow breathe a bit
    },

    {
      headerName: "Tax Update Date",
      field: "UpdatedDate",
      flex: 1,
      sortable: false,
      cellRenderer: (params: any) => CreatedDateRenderer(params.data.UpdatedDate)
    },

    {
      headerName: "Action",
      field: "",
      cellRenderer: DocumentActionsCellRenderer,
      pinned: "right",
      maxWidth: 170,
      minWidth: 170,
      sortable: false
    },
    {
      field: "InternalK1SelectedReturnId",
      hide: true,         // not visible in the grid
      suppressToolPanel: true // optional: also hides it from column chooser
    }
  ];

  const onSelectionChanged = (selectedRows: any[]) => {
    console.log(selectedRows);
    setSelectedRows(selectedRows);
  };


  const [documentColumnDefs, setDocumentColumnDefs] = useState<any[]>(defaultDocumentColumnDefs);

  const onReturnIdChange = (selectedOption: any) => {
    setSelectedReturnId(selectedOption);
  }

  const getAllReturnIds = async () => {
    const returnIds = await getReturnIds(clientmasterid);
    const options = returnIds.map(item => ({
      label: item.ReturnId,
      value: item.ReturnId
    }))
      .sort((a, b) => {
        const versionA = parseInt(a.value.split(":").pop()?.substring(1) || "0", 10);
        const versionB = parseInt(b.value.split(":").pop()?.substring(1) || "0", 10);
        return versionA - versionB;
      });

    setReturnIdOptions(options);
    // setSelectedReturnId(options[0]);
    if (options.length > 0) {
      setSelectedReturnId(options[0]); // triggers the 2nd effect
    }
    setIsOptionValid(true);
    // setEffectiveReturnId("Selected")
  }

  const removeCachedPages = () => {
    for (let count = 1; count <= totalPagesOfSelectedFile; count++) {
      localStorage.removeItem(`Page ${count}`)
    }
  }


  const internalK1PulldataModelCloseHandler = (selectedReturnId?: string) => {
  setShowInternalK1PullModal(false);
  if (!selectedReturnId || !pendingDocId) return;
  console.log(selectedReturnId);
  console.log(pendingDocId);

  setDocumentInternalK1SelectedParentId(prev => ({
    ...prev,
    [pendingDocId]: selectedReturnId, // both strings
  }));
  // 4a) Update your React data (source of truth)
  setDocumentsData(prev =>
    prev.map(r =>
      r.DocumentId === pendingDocId
        ? {
            ...r,
            InternalK1SelectedReturnId: selectedReturnId,
            Status: 'Return Selected',
            FileName: { type: 'button', placeholder: selectedReturnId, url: '' },
          }
        : r
    )
  );

  // 4b) Update the rendered row instantly (no refresh needed)
  const n = clickedRowNodeRef.current;
  n?.setDataValue('InternalK1SelectedReturnId', selectedReturnId);
  n?.setDataValue('Status', 'Return Selected');
  n?.setDataValue('FileName', { type: 'button', placeholder: selectedReturnId, url: '' });

  // cleanup
  setPendingDocId(null);
  clickedRowNodeRef.current = null;
};

  const importToTax = () => {  
    setImportToTaxFlag(true)
    setImportToTaxConfirmModal(true)
  }

  const navigateToReports = (orchestratorId: any) => {
    transporter("maintenancereport",
      {
        "maintenancereport_option":
        {
          "id": orchestratorId,
          "flow_name": "",
          "default_flow_name": "",
        }
      }
    );
  }

  return (
    <>
      {/* this is for tax forms */}
      {comparisonModalShow &&
        <ComparisonModal
          show={comparisonModalShow}
          comparisondata={comparisonData}
          onHide={() => {
            setComparisonModalShow(false);
          }
          }
          refresh={() => getDocumentsByClientId()}
        />}
      {uploadDocumentsModal &&
        <UploadDocuments
          show={uploadDocumentsModal}
          onHide={() => setUploadDocumentsModal(false)}
          clientmasterid={clientmasterid}
          refresh={() => getDocumentsByClientId()}
          setfileuploading={(flag: any) => setFileUploadingFlag(flag)}
          fileUploading={fileUploadingFlag}
          filetype={fileType}
          floworchestratoridexcelimport={flowOrchestratorIdExcelImport}
        />
      }
      {documentPreviewModal &&
        <DocumentPreviewModal
          show={documentPreviewModal}
          pdfFileUrl={pdfFileUrl}
          onHide={() => setDocumentPreviewModal(false)}
        />
      }
      
      {/* this is for external k1s */}
      {comparisonWindowModalState &&
        <ComparisonFullWindowModal
          show={comparisonWindowModalState}
          onHide={() => {
            setComparisonWindowModalState(false)
            removeCachedPages()
          }
          }
          comparisondata={comparisonData}
          settotalpages={(pages: any) => setTotalPages(pages)}
          refresh={() => getDocumentsByClientId()}
        />
      }
      {showInternalK1HierarchyModal &&
        <InternalK1Hierarchy
          show={showInternalK1HierarchyModal}
          onHide={() => setShowInternalK1HierarchyModal(false)}
          returnid={selectedReturnId?.value}
          refresh={() => getDocumentsByClientId}
          clientMasterId={clientmasterid}
        />
      }

      {showInternalK1PullModal &&
        <InternalK1PullDataModal
          show={showInternalK1PullModal}
          onHide={() => setShowInternalK1PullModal(false)}
          onSelectComplete={(id: string) => internalK1PulldataModelCloseHandler(id)}
          ssnoreinofclient={"123-65-3263"}
          refresh={() => getDocumentsByClientId}
          selectedParent={selectedParent}
          selectedReturnIdFromInternalK1={documentInternalK1SelectedParentId}
        />
      }

      {showActivityMappingmodal &&
        <ActivityMapping
          show={showActivityMappingmodal} 
          onHide={() => setShowActivityMappingmodal(false)}
          // refresh={() => getDocumentsByClientId()}
          returnid={selectedReturnId?.value}
          parentreturnid={parentReturnId}
          parentName={parentName}
          clientname={clientname}
          clientmasterid={clientmasterid}
          documentid={documentId}
          sourceidentifier={sourceIdentifier}
          setinternalk1activities={setInternalK1Activities}
          internalk1activities={internalK1Activities}
        />
      }

      {importToTaxConfirmModal &&
        <ConfirmImportToTaxModal
          show={importToTaxConfirmModal}
          selectedrows={selectedRows}
          onHide={() => setImportToTaxConfirmModal(false)}
          refresh={() => getDocumentsByClientId()}          
          importtotaxflag={() => setImportToTaxFlag(false)}
          returnid={selectedReturnId}
          clientmasterid={clientmasterid}
          internalk1activities={internalK1Activities}
        />
      }
      {showExcelExportModal &&
        <ConfirmExportToExcelModal
          show={showExcelExportModal}
          selectedrows={selectedRows}
          onHide={() => setShowExcelExportModal(false)}
          refresh={() => getDocumentsByClientId()}          
          importtotaxflag={() => setImportToTaxFlag(false)}
          returnid={selectedReturnId}
          clientmasterid={clientmasterid}
          internalk1activities={internalK1Activities}
        />
      }

      <Modal
        show={show}
        onHide={() => onHide()}
        size="lg"
        centered
        className={styles.editClientModal}
      >
        <Modal.Header className={styles.editClientModalHeader}>
          <div className={styles.editClientModalHeaderContent}>
          <Row style={{ width: "100%" }}>
            <Col md={12}>
              <span className={styles.editClientModalHeaderTitle}>Uploaded Tax Files</span>
            </Col>
          </Row>
          <Row style={{ width: "100%" }}>
            <Col md={6} style={{ paddingRight: 0 }}>
              <span className={styles.editClientModalSubHeaderTitle}>{`${clientid} - ${clientname}`}</span>
            </Col>
          </Row>
          </div>
          <button
            type="button"
            className={styles.closeButton}
            onClick={() => onHide()}
            aria-label="Close"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </Modal.Header>
        <Modal.Body className={styles.editClientModalBody}>
          <Row className={`no-gutter ${styles.editorMainButtons}`}>
            <Col md={12} className="d-flex justify-content-between align-items-end">
              <div>
                <label>&nbsp;Return Id <span className="madatory">*</span></label>
                <Select<ReturnIdOption, false>
                  onChange={onReturnIdChange}
                  value={selectedReturnId}
                  placeholder={<div>Select Return Id</div>}
                  options={returnIdOptions}
                  className={`custom-select ${styles.returnIdSelect}`}
                  classNamePrefix="react-select"

                   menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                    menuPosition="fixed" // avoids clipping from overflow parents
                    styles={{
                      menuPortal: (base: React.CSSProperties) => ({ ...base, zIndex: 9999 }),
                      menu: (base: React.CSSProperties) => ({ ...base, zIndex: 9999 }),
                    }}
                />
              </div>
              <div className="d-flex align-items-end" >
                <Dropdown>
                  <Dropdown.Toggle
                    className={styles.importToTaxDropdown}
                    id="add-client-dropdown"
                  >
                    <Icon.BoxArrowInUpRight size={16} />
                    &nbsp;
                    Reports
                  </Dropdown.Toggle>

                  <Dropdown.Menu className={styles.importToTaxMenu}>
                      <Dropdown.Item 
                        className={styles.importToTaxMenuItem}
                        key={"directImport"}
                        onClick={() => navigateToReports(flowOrchestratorId)}
                      >
                        Direct Import Report
                      </Dropdown.Item>

                      <Dropdown.Item 
                        className={styles.importToTaxMenuItem}
                        key={"excelImport"}
                        onClick={() => navigateToReports(flowOrchestratorIdExcelImport)}
                      >
                        Excel Import Return
                      </Dropdown.Item>

                  </Dropdown.Menu>
                </Dropdown>

                <Dropdown>
                  <Dropdown.Toggle
                    className={styles.importToTaxDropdown}
                    id="add-client-dropdown"
                    disabled={selectedRows.length === 0}
                  >
                    Import To Tax
                  </Dropdown.Toggle>

                  <Dropdown.Menu className={styles.importToTaxMenu}>
                      <Dropdown.Item 
                        className={styles.importToTaxMenuItem}
                        key={"directImport"}
                        onClick={() => importToTax()}
                      >
                        Direct Import
                      </Dropdown.Item>

                      <Dropdown.Item 
                        className={styles.importToTaxMenuItem}
                        key={"excelImport"}
                        onClick={() => {
                          setFileType("excel")
                          setUploadDocumentsModal(true)
                        }}
                      >
                        Excel Import
                      </Dropdown.Item>

                  </Dropdown.Menu>
                </Dropdown>

                <CustomButton
                  progress={false}
                  onclick={() => setShowExcelExportModal(true)}
                  content={"Worksheets"}
                  disable={selectedRows.length === 0}
                />
                <CustomButton
                  progress={fileUploadingFlag}
                  onclick={() => {
                    setFileType("pdf")
                    setUploadDocumentsModal(true)
                  }}
                  content={fileUploadingFlag ? "Uploading" : "Upload"}
                />
                <RefreshButton
                  refreshflag={refreshGrid}
                  refreshfunction={() => getDocumentsByClientId()}
                />
              </div>
            </Col>

          </Row>

          <Row className='no-gutter'>
            <Col md={12}>
              <div style={gridStyle}>                
                <CygnusGrid
                  key={key}
                  ref={gridRef}
                  columnDefs={documentColumnDefs}
                  fetchData={async () => {
                    // Since this is not paginated, just return everything
                    return { records: documentsData, totalCount: documentsData.length };
                  }}
                  dataIdentifier="DocumentId"
                  rowSelection={"multiple"}
                  onLoadingChange={setRefreshGrid}
                  cachedIsLoading={refreshGrid}
                  cachedData={documentsData}
                  setCachedData={setDocumentsData}
                  onSelectionChange={onSelectionChanged}
                  getRowId={(p) => p.data.DocumentId}
                  onRowClicked={(event) => {
                    clickedRowNodeRef.current = event.node;
                  }}
                  gridOptions={{
                    rowSelection: {
                      mode: 'multiRow',
                      checkboxes: true,
                      headerCheckbox: true,
                      hideDisabledCheckboxes: false,
                      isRowSelectable: (node: any) => {
                        const s = node?.data?.Status;
                        return !!s && selectableStatuses.some(
                          x => x.toLowerCase() === String(s).toLowerCase()
                        );
                      },
                    },
                    selectionColumnDef: {
                      pinned: 'left',
                      width: 48,
                      headerTooltip: 'Select/deselect all selectable rows',
                      suppressHeaderMenuButton: true,
                      tooltipValueGetter: p => {
                        const row = p.node?.data ?? {};
                        const status = String(row.Status ?? '');
                        const type = row.FormType ?? row.DocumentType ?? 'Document';

                        const isAllowed = selectableStatuses
                          .some(x => x.toLowerCase() === status.toLowerCase());

                        if (isAllowed) return '';
                        if (type === 'Internal Schedule K-1') return "Please select a Return Id by clicking ⬇️ in actions";
                        if (status === "Processing") return "Waiting for processing";
                        if (status === "Error") return "Unable to process this document";
                        return "Please approve this document first";
                      },
                    },
                    tooltipShowDelay: 50,
                    tooltipHideDelay: 1000,
                  }}
                  rowModelType="clientSide"
                />
              </div>
            </Col>
          </Row>

        </Modal.Body>
      </Modal>
    </>
  )
};

export default ClientDocuments;